import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Telefonnummer} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-telefonnummer',
  templateUrl: './telefonnummer.component.html',
  styleUrls: ['./telefonnummer.component.scss']
})
export class TelefonnummerComponent extends FormBaseComponent<Telefonnummer> {

  @Input()
  public showRemoveTelefonnummerButton = false;

  @Input()
  public stammdatenTelefonnummern: Array<Telefonnummer>;

  @Output()
  public removeTelefonnummerClicked: EventEmitter<number> = new EventEmitter<number>();

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  public removeTelefonnummer(): void {
    this.removeTelefonnummerClicked.emit(this.index);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      vorwahlInternational: [this.data.vorwahlInternational, [
        this.validatorService.minLength(2),
        this.validatorService.maxLength(7),
        this.validatorService.pattern('^(00|\\+)\\d+$',
          this.translateService.instant('COMMON_UI.VALIDATION.VORWAHL_INT_INVALID_PATTERN'))
      ]],
      vorwahlNational: [this.data.vorwahlNational, [
        this.validatorService.minLength(1),
        this.validatorService.maxLength(10),
        this.validatorService.pattern(/^\d{1,10}$/),
        this.validatorService.conditionalValidator(() => !!this.data.rufnummer || !!this.data.vorwahlInternational,
          this.validatorService.required())
      ]],
      rufnummer: [this.data.rufnummer, [
        this.validatorService.minLength(2),
        this.validatorService.maxLength(13),
        this.validatorService.pattern(/^(?=.{2,13}$)\d+-?\d+$/),
        this.validatorService.conditionalValidator(() => !!this.data.vorwahlNational || !!this.data.vorwahlInternational,
          this.validatorService.required())
      ]],
      notiz: [this.data.notiz]
    });
  }
}
